import {Component, OnInit} from '@angular/core';
import {FormBaseComponent} from '@utils-lib';
import {OrgantraegerDetail} from '@nachdigal';
import {FormBuilder} from '@angular/forms';
import {DatevMessageService} from '@datev/ngx-ui-components';

@Component({
  selector: 'common-ui-koerperschaftssteuer',
  templateUrl: './koerperschaftssteuer.component.html'
})
export class KoerperschaftssteuerComponent extends FormBaseComponent<OrgantraegerDetail> implements OnInit {

  constructor(private readonly formBuilder: FormBuilder,
              protected readonly messageService: DatevMessageService) {
    super(messageService);
  }

  public ngOnInit(): void {
    super.ngOnInit();
    if (this.data.isKStUndGewStOrgangesellschaft === undefined) {
      this.data.isKStUndGewStOrgangesellschaft = false;
    }
    if (this.data.datumGewinnAbfVertrag === undefined) {
      this.data.datumGewinnAbfVertrag = null;
    }
  }

  protected createForm(): void {
    this.form = this.formBuilder.group({
      isKStUndGewStOrgangesellschaft: [this.data.isKStUndGewStOrgangesellschaft, []],
      datumGewinnAbfVertrag: [this.data.datumGewinnAbfVertrag, []]
    });
  }
}
